import RenderlessSearch from "./RenderlessSearch.vue";
import Search from "./Search.vue";
import SearchResult from "./SearchResult.vue";
import mixin from "./mixin";

const meilisearchSearchComponents = { 
    RenderlessSearch,
    Search,
    SearchResult 
}

export * from "./mixin";
export { 
    RenderlessSearch as MeilisearchRenderlessSearch,
    Search as MeilisearchSearch,
    SearchResult as MeilisearchSearchResult,
    mixin as searchMixin
}

export default meilisearchSearchComponents;
